import { Box, Typography, Stack, TextField, Paper, Divider } from "@mui/material";
import Header from "../../../components/Header";
import TableLicensesAgent from "./components/TableLicensesAgent";
import API from "../../../api";
import { useEffect, useMemo, useState } from "react";

const LicensesAgent = () => {
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setLoading(true);

    API.getLicensesAgentByTenant()
      .then((res) => {
        
        setLicenses(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        setLicenses([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const totalCount = useMemo(() => licenses?.length ?? 0, [licenses]);

  const visibleCount = useMemo(() => {
    if (!search?.trim()) return licenses?.length ?? 0;

    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(escaped, "i");

    return (licenses || []).filter(
      (item) =>
        regex.test(item.codiceAttivazione || "") ||
        regex.test(String(item.device_limit ?? ""))
    ).length;
  }, [licenses, search]);

  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
      }}
    >
      <Header title={"Agent Licenses"} />

      <Paper
        elevation={0}
        sx={{
          mt: 2,
          mb: 2,
          p: 2,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          backgroundImage:
            "linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0))",
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ xs: "stretch", md: "center" }}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Typography sx={{ fontSize: 14, opacity: 0.8 }}>
              Search license
            </Typography>

            <TextField
              size="small"
              variant="outlined"
              placeholder="Type activation code or device limit…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{
                width: { xs: "100%", sm: 360 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: 999,
                  backgroundColor: "background.paper",
                },
                "& fieldset": { borderColor: "divider" },
              }}
            />
          </Stack>

          <Box
            sx={{
              px: 1.5,
              py: 0.75,
              borderRadius: 999,
              border: "1px solid",
              borderColor: "divider",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography sx={{ fontSize: 13, opacity: 0.9 }}>
              Total
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 700 }}>
              {totalCount}
            </Typography>
          </Box>
        </Stack>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderLeft: "4px solid",
            borderLeftColor: "primary.main",
            backgroundImage:
              "linear-gradient(90deg, rgba(25,118,210,0.12), rgba(0,0,0,0))",
          }}
        >
          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
            Licenses
          </Typography>

          <Typography sx={{ fontSize: 13, opacity: 0.8 }}>
            {loading ? "Loading..." : `${visibleCount} license`}
          </Typography>
        </Box>

        <Divider />

        <Box sx={{ p: 2 }}>
          <TableLicensesAgent
            data={licenses}
            search={search}
            loading={loading}
            tableHeight={{ xs: 420, md: 520, lg: 600 }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default LicensesAgent;